import "./ServiceAreas.module.css";
import MainNavigation from "@/reusable_sections/Header";
import WhereWeWork from "./sections/WhereWeWork";
import SiteFooter from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <MainNavigation />
      <WhereWeWork />
      <SiteFooter />
    </div>;
}